import React, { useRef } from "react";

function Upload(props) {
  const uploadInput = useRef();
  const fnUpload = () => {
    uploadInput.current.click();
  };
  
  return (
  	<>
      <input type="file" className={`input_file ${props.type}`} ref={uploadInput} />
      <button onClick={fnUpload} className={`btn_upload ${props.className}`}>
        {props.title && props.title}
      </button>
    </>
  );
} 

export default Upload;